module.exports = __webpack_public_path__ + "static/CircularStd-MediumItalic-21a7520d477ce7c4202f49af5708c586.woff";